
export default function Footer() {
  return (
    <footer className="bg-black/50 border-t border-gray-800">
      <div className="container-max py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo ve Açıklama */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/1690b37a69531419192e3d0930ef8929.jpeg" 
                alt="Clear Aligner Box" 
                className="h-12 w-12 object-contain mr-3"
              />
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Şeffaf plak tedavisi ile gülüşünüzü mükemmelleştirin. 
              Profesyonel hizmet ve kaliteli ürünlerle yanınızdayız.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/clearalignerbox?igsh=OWFrY2x0ODE5enJt&utm_source=qr" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gold-text transition-colors"
              >
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a 
                href="https://wa.me/905078064479" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gold-text transition-colors"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
              </a>
              <a 
                href="mailto:clearalignerbox@gmail.com"
                className="text-gray-400 hover:text-gold-text transition-colors"
              >
                <i className="ri-mail-line text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Hızlı Linkler */}
          <div>
            <h3 className="text-lg font-semibold gold-text mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <a href="#why-transparent" className="text-gray-400 hover:text-gold-text transition-colors">
                  Neden Şeffaf Plak?
                </a>
              </li>
              <li>
                <a href="#instructions" className="text-gray-400 hover:text-gold-text transition-colors">
                  Kullanım Talimatları
                </a>
              </li>
              <li>
                <a href="#cleaning-guide" className="text-gray-400 hover:text-gold-text transition-colors">
                  Temizlik Rehberi
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-gray-400 hover:text-gold-text transition-colors">
                  Galeri
                </a>
              </li>
              <li>
                <a href="#faq" className="text-gray-400 hover:text-gold-text transition-colors">
                  Sık Sorulan Sorular
                </a>
              </li>
            </ul>
          </div>

          {/* İletişim */}
          <div>
            <h3 className="text-lg font-semibold gold-text mb-4">İletişim</h3>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:+905078064479" className="hover:text-gold-text transition-colors">
                  +90 507 806 44 79
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <a href="mailto:clearalignerbox@gmail.com" className="hover:text-gold-text transition-colors">
                  clearalignerbox@gmail.com
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-instagram-line mr-2"></i>
                <a 
                  href="https://www.instagram.com/clearalignerbox?igsh=OWFrY2x0ODE5enJt&utm_source=qr" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold-text transition-colors"
                >
                  @clearalignerbox
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Alt Kısım */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 Clear Aligner Box. Tüm hakları saklıdır.
          </p>
          <div className="flex space-x-6 text-sm">
            <a href="/kvkk" className="text-gray-400 hover:text-gold-text transition-colors">
              KVKK
            </a>
            <a href="/cerez-politikasi" className="text-gray-400 hover:text-gold-text transition-colors">
              Çerez Politikası
            </a>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-gold-text transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}